function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\uD83C\\uDF6A",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "index-desktop-copy-7",
  transform: "translate(-1353.000000, -583.000000)",
  fill: "#E10009",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Arrow_2304628",
  transform: "translate(1364.500000, 589.500000) scale(1, -1) rotate(-90.000000) translate(-1364.500000, -589.500000) translate(1358.500000, 578.500000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.500000, 0.500000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.0026778125,10.4954441 C0.0106329404,10.8479133 0.144596644,11.1847925 0.378637187,11.4408712 L8.62867156,20.3391763 C9.15719854,20.9045628 10.0278795,20.9206021 10.5754949,20.3750397 C11.1231103,19.8294773 11.1412071,18.9279921 10.6159591,18.359339 L3.27906219,10.4509525 L10.6159591,2.54256254 C11.1412071,1.97390938 11.1231103,1.07242427 10.5754949,0.526861864 C10.0278795,-0.0187005444 9.15719854,-0.00266130197 8.62867156,0.562725254 L0.378637187,9.46103034 C0.123915317,9.73935351 -0.0116286637,10.1122889 0.0026778125,10.4954441 L0.0026778125,10.4954441 Z",
  id: "Path"
})))));
function SvgArrowIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "13px",
    viewBox: "0 0 23 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_Arrow_2304628") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIconRed);
export default __webpack_public_path__ + "static/media/arrow-icon--red.21b930c28d8daf2c17d944c1376508ea.svg";
export { ForwardRef as ReactComponent };